import type { TourStep } from "@repo/dashboard-core";

const k = (id: string, suffix: string) => `steps.${id}.${suffix}`;

export const tourSteps: TourStep[] = [
  {
    id: "welcome",
    bannerKey: k("welcome", "banner"),
    iconName: "rocket",
    headingKey: k("welcome", "heading"),
    descriptionKey: k("welcome", "description"),
  },
  {
    id: "money-back",
    bannerKey: k("money-back", "banner"),
    iconName: "coins",
    headingKey: k("money-back", "heading"),
    descriptionKey: k("money-back", "description"),
    blocks: [
      { kind: "highlight", valueKey: k("money-back", "amount") },
      {
        kind: "note",
        iconName: "calendar",
        titleKey: k("money-back", "auto-renew"),
      },
    ],
    footerNote: { iconName: "alert", textKey: k("money-back", "footer") },
  },
  {
    id: "sms-calls",
    bannerKey: k("sms-calls", "banner"),
    iconName: "chat",
    headingKey: k("sms-calls", "heading"),
    descriptionKey: k("sms-calls", "description"),
    blocks: [
      { kind: "highlight", valueKey: k("sms-calls", "units") },
      {
        kind: "usageOptions",
        titleKey: k("sms-calls", "usage-title"),
        conjunctionKey: k("sms-calls", "conjunction"),
        options: [
          {
            iconName: "messages",
            labelKey: k("sms-calls", "option-sms-label"),
          },
          { iconName: "phone", labelKey: k("sms-calls", "option-calls-label") },
        ],
      },
    ],
    footerNote: { iconName: "alert", textKey: k("sms-calls", "footer") },
  },
  {
    id: "discounts",
    bannerKey: k("discounts", "banner"),
    iconName: "tag",
    headingKey: k("discounts", "heading"),
    descriptionKey: k("discounts", "description"),
    blocks: [
      {
        kind: "highlight",
        titleKey: k("discounts", "highlight-title"),
        valueKey: k("discounts", "highlight-value"),
        subtitleKey: k("discounts", "highlight-subtitle"),
      },
      {
        kind: "example",
        titleKey: k("discounts", "example-title"),
        lines: [
          {
            labelKey: k("discounts", "example-topup-label"),
            valueKey: k("discounts", "example-topup-value"),
          },
          {
            labelKey: k("discounts", "example-discount-label"),
            valueKey: k("discounts", "example-discount-value"),
            emphasis: "negative",
          },
          {
            labelKey: k("discounts", "example-total-label"),
            valueKey: k("discounts", "example-total-value"),
            emphasis: "total",
          },
        ],
      },
    ],
  },
  {
    id: "esim",
    bannerKey: k("esim", "banner"),
    iconName: "globe",
    headingKey: k("esim", "heading"),
    descriptionKey: k("esim", "description"),
    blocks: [
      {
        kind: "featureList",
        layout: "list",
        items: [
          {
            iconName: "check",
            labelKey: k("esim", "feature-1-label"),
            subLabelKey: k("esim", "feature-1-sub"),
          },
          {
            iconName: "check",
            labelKey: k("esim", "feature-2-label"),
            subLabelKey: k("esim", "feature-2-sub"),
          },
          {
            iconName: "check",
            labelKey: k("esim", "feature-3-label"),
            subLabelKey: k("esim", "feature-3-sub"),
          },
          {
            iconName: "check",
            labelKey: k("esim", "feature-4-label"),
            subLabelKey: k("esim", "feature-4-sub"),
          },
        ],
      },
    ],
  },
  {
    id: "support",
    bannerKey: k("support", "banner"),
    iconName: "chatBot",
    headingKey: k("support", "heading"),
    descriptionKey: k("support", "description"),
    blocks: [
      {
        kind: "featureList",
        layout: "list",
        items: [
          {
            iconName: "questionCircle",
            labelKey: k("support", "feature-1-label"),
            subLabelKey: k("support", "feature-1-sub"),
          },
          {
            iconName: "phone",
            labelKey: k("support", "feature-2-label"),
            subLabelKey: k("support", "feature-2-sub"),
          },
          {
            iconName: "alert",
            labelKey: k("support", "feature-3-label"),
            subLabelKey: k("support", "feature-3-sub"),
          },
        ],
      },
    ],
    footerNote: { iconName: "chat", textKey: k("support", "footer") },
  },
  {
    id: "profile",
    bannerKey: k("profile", "banner"),
    iconName: "user",
    headingKey: k("profile", "heading"),
    descriptionKey: k("profile", "description"),
    blocks: [
      {
        kind: "featureList",
        layout: "grid",
        items: [
          {
            iconName: "user",
            labelKey: k("profile", "feature-1-label"),
            subLabelKey: k("profile", "feature-1-sub"),
          },
          {
            iconName: "bell",
            labelKey: k("profile", "feature-2-label"),
            subLabelKey: k("profile", "feature-2-sub"),
          },
          {
            iconName: "addressBook",
            labelKey: k("profile", "feature-3-label"),
            subLabelKey: k("profile", "feature-3-sub"),
          },
          {
            iconName: "creditCard",
            labelKey: k("profile", "feature-4-label"),
            subLabelKey: k("profile", "feature-4-sub"),
          },
        ],
      },
    ],
  },
];
